import script from "./OrderPopupBtnSmall.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderPopupBtnSmall.vue?vue&type=script&setup=true&lang=js"

import "./OrderPopupBtnSmall.vue?vue&type=style&index=0&id=546f065e&setup=true&lang=css"

const __exports__ = script;

export default __exports__